import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FFFFFF', // Warm Beige for Luxury Real Estate Vibes
      secondary: '#32597D24',
      another: '#EAF5F5'
    },

    secondary: {
      main: '#F2A341', // Gold 
      sec: '#31587c',
      other: '#32597db3'
    },
    text: {
      primary: '#1CA6AF', // Dark Coffee 
      secondary: '#31587C'
     

    },
    background: {
      default: '#EAF5F5', // Same as primary background for consistency
    },
  },
  padding: {
    primary: {
        main: '30px'
    }
  }
});

export default theme;
